/**
 * DiagnosticDiagramDemo — RMA/Returns use case.
 * Interactive flowchart for hardware diagnostics.
 */
import React, { useState } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import DiagnosticDiagram from '../../components/useCases/DiagnosticDiagram';

const STEPS = [
  { id: 'power', label: 'Does the device power on when you press the button?', yes: 'resolved', no: 'cable' },
  { id: 'cable', label: 'Is the power cable firmly connected at both ends?', yes: 'outlet', no: 'resolved' },
  { id: 'outlet', label: 'Have you verified the outlet works (try another device)?', yes: 'device', no: 'resolved' },
  { id: 'device', label: 'Try a different power outlet. Does it work now?', yes: 'resolved', no: 'rma' },
  { id: 'rma', label: 'Device may be faulty. Initiate RMA?', yes: 'resolved', no: null },
  { id: 'resolved', label: 'Diagnostic complete', yes: null, no: null },
];

export default function DiagnosticDiagramDemo({ onBack }) {
  const [value, setValue] = useState(null);

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Answer Yes/No to walk through the diagnostic. Used for RMA eligibility and troubleshooting.
      </Typography>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <DiagnosticDiagram
          value={value}
          onChange={(e) => setValue(e?.target?.value || e)}
          label="Device not powering on — diagnostic"
          steps={STEPS}
        />
      </Paper>
    </Box>
  );
}
